import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellGreenSizeS from './IconWellGreen_size_s';

const props: CreateIconArguments = {
  l: IconWellGreenSizeS,
  m: IconWellGreenSizeS,
  s: IconWellGreenSizeS,
  xs: IconWellGreenSizeS,
  name: 'IconWellGreen',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
